'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IFrameResource = exports.HtmlResource = exports.StaticResource = undefined;

var _staticResource = require('./static-resource');

var _staticResource2 = _interopRequireDefault(_staticResource);

var _htmlResource = require('./html-resource');

var _htmlResource2 = _interopRequireDefault(_htmlResource);

var _iframeResource = require('./iframe-resource');

var _iframeResource2 = _interopRequireDefault(_iframeResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.StaticResource = _staticResource2.default;
exports.HtmlResource = _htmlResource2.default;
exports.IFrameResource = _iframeResource2.default;
//# sourceMappingURL=index.js.map


// WEBPACK FOOTER //
// ./src/resources/index.js